// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container .login-container {
  height: 100vh;
}
.app-container .icon-home .image-stream {
  height: 100px;
}
.app-container .icon-nav-desktop .image-stream {
  height: 75px;
}
.app-container .icon-nav-mobile .image-stream {
  height: 50px;
}
.app-container .image-picker-component .image-stream {
  height: 100px;
}
.app-container .MuiButton-outlinedPrimary {
  border-radius: 100px;
  border-color: var(--primaryBase);
  color: var(--primaryBase);
}
.app-container .MuiButton-outlinedPrimary:hover {
  background-color: var(--primaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-outlinedSecondary {
  border-radius: 100px;
  border-color: var(--secondaryBase);
  color: var(--secondaryBase);
}
.app-container .MuiButton-outlinedSecondary:hover {
  background-color: var(--secondaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-outlinedWarning {
  border-radius: 100px;
  border-color: var(--primaryBase);
  color: var(--primaryBase);
}
.app-container .MuiButton-outlinedWarning:hover {
  background-color: var(--primaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-containedPrimary {
  border-radius: 100px;
  background-color: var(--primaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-containedPrimary:hover {
  background-color: var(--secondaryBase);
}
.app-container .MuiButton-containedSecondary {
  border-radius: 16px;
  background-color: var(--tertiaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-containedSecondary:hover {
  background-color: var(--tertiaryBase);
}
.app-container .MuiButton-containedWarning {
  border-radius: 16px;
  background-color: var(--primaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButton-containedWarning:hover {
  background-color: var(--primaryBase);
}
.app-container .MuiButton-textPrimary {
  color: var(--primaryBase);
  text-transform: capitalize;
}
.app-container .MuiButton-textPrimary:hover, .app-container .MuiButton-textPrimary.active {
  text-decoration: underline;
}
.app-container .MuiButton-textSecondary {
  color: var(--secondaryBase);
  text-transform: capitalize;
}
.app-container .MuiButton-textSecondary:hover, .app-container .MuiButton-textSecondary.active {
  text-decoration: underline;
}
.app-container .MuiButton-textWarning {
  color: var(--primaryBase);
  text-transform: capitalize;
}
.app-container .MuiButton-textWarning:hover, .app-container .MuiButton-textWarning.active {
  text-decoration: underline;
}
.app-container .MuiButtonGroup-root .MuiButton-colorPrimary {
  border-radius: 100px;
  padding: 10px 24px;
  background-color: var(--primaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButtonGroup-root .MuiButton-colorPrimary:hover {
  background-color: var(--secondaryBase);
}
.app-container .MuiButtonGroup-root .MuiButton-colorPrimary.active {
  background-color: var(--secondaryBase);
}
.app-container .MuiButtonGroup-root .MuiButton-colorInfo {
  background-color: var(--whiteBase);
  color: var(--primaryBase);
  border-color: var(--greyBase) !important;
}
.app-container .MuiButtonGroup-root .MuiButton-colorInfo:hover, .app-container .MuiButtonGroup-root .MuiButton-colorInfo.active {
  background-color: var(--secondaryBase);
  color: var(--whiteBase);
}
.app-container .MuiButtonGroup-root .MuiButtonGroup-firstButton {
  border-color: var(--whiteBase);
  border-radius: 10px 0px 0px 10px;
}
.app-container .MuiButtonGroup-root .MuiButtonGroup-middleButton {
  border-color: var(--whiteBase);
}
.app-container .MuiButtonGroup-root .MuiButtonGroup-lastButton {
  border-color: var(--whiteBase);
  border-radius: 0px 10px 10px 0px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAIQ;EACI,aAAA;AAFZ;AAOQ;EACI,YAAA;AALZ;AAUQ;EACI,YAAA;AARZ;AAaQ;EACI,aAAA;AAXZ;AAeI;EACI,oBAAA;EAEA,gCAAA;EACA,yBAAA;AAdR;AAgBQ;EACI,oCAAA;EACA,uBAAA;AAdZ;AAkBI;EACI,oBAAA;EAEA,kCAAA;EACA,2BAAA;AAjBR;AAmBQ;EACI,sCAAA;EACA,uBAAA;AAjBZ;AAqBI;EACI,oBAAA;EAEA,gCAAA;EACA,yBAAA;AApBR;AAsBQ;EACI,oCAAA;EACA,uBAAA;AApBZ;AAwBI;EACI,oBAAA;EAEA,oCAAA;EACA,uBAAA;AAvBR;AAyBQ;EACI,sCAAA;AAvBZ;AA2BI;EACI,mBAAA;EAEA,qCAAA;EACA,uBAAA;AA1BR;AA4BQ;EACI,qCAAA;AA1BZ;AA8BI;EACI,mBAAA;EAEA,oCAAA;EACA,uBAAA;AA7BR;AA+BQ;EACI,oCAAA;AA7BZ;AAiCI;EACI,yBAAA;EACA,0BAAA;AA/BR;AAiCQ;EAEI,0BAAA;AAhCZ;AAoCI;EACI,2BAAA;EACA,0BAAA;AAlCR;AAoCQ;EAEI,0BAAA;AAnCZ;AAuCI;EACI,yBAAA;EACA,0BAAA;AArCR;AAuCQ;EAEI,0BAAA;AAtCZ;AA2CQ;EACI,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;AAzCZ;AA2CY;EACI,sCAAA;AAzChB;AA4CY;EACI,sCAAA;AA1ChB;AA8CQ;EACI,kCAAA;EACA,yBAAA;EACA,wCAAA;AA5CZ;AA8CY;EAEI,sCAAA;EACA,uBAAA;AA7ChB;AAiDQ;EACI,8BAAA;EACA,gCAAA;AA/CZ;AAmDQ;EACI,8BAAA;AAjDZ;AAoDQ;EACI,8BAAA;EACA,gCAAA;AAlDZ","sourcesContent":[".app-container {\n    .login-container {\n        height: 100vh;\n    }\n\n    .icon-home {\n        .image-stream {\n            height: 100px;\n        }\n    }\n\n    .icon-nav-desktop {\n        .image-stream {\n            height: 75px;\n        }\n    }\n\n    .icon-nav-mobile {\n        .image-stream {\n            height: 50px;\n        }\n    }\n\n    .image-picker-component {\n        .image-stream {\n            height: 100px;\n        }\n    }\n\n    .MuiButton-outlinedPrimary {\n        border-radius: 100px;\n        //padding: 10px 24px;\n        border-color: var(--primaryBase);\n        color: var(--primaryBase);\n\n        &:hover {\n            background-color: var(--primaryBase);\n            color: var(--whiteBase);\n        }\n    }\n\n    .MuiButton-outlinedSecondary {\n        border-radius: 100px;\n        //padding: 10px 24px;\n        border-color: var(--secondaryBase);\n        color: var(--secondaryBase);\n\n        &:hover {\n            background-color: var(--secondaryBase);\n            color: var(--whiteBase);\n        }\n    }\n\n    .MuiButton-outlinedWarning {\n        border-radius: 100px;\n        //padding: 10px 24px;\n        border-color: var(--primaryBase);\n        color: var(--primaryBase);\n\n        &:hover {\n            background-color: var(--primaryBase);\n            color: var(--whiteBase);\n        }\n    }\n\n    .MuiButton-containedPrimary {\n        border-radius: 100px;\n        //padding: 10px 24px;\n        background-color: var(--primaryBase);\n        color: var(--whiteBase);\n\n        &:hover {\n            background-color: var(--secondaryBase);\n        }\n    }\n\n    .MuiButton-containedSecondary {\n        border-radius: 16px;\n       // padding: 8px 16px;\n        background-color: var(--tertiaryBase);\n        color: var(--whiteBase);\n\n        &:hover {\n            background-color: var(--tertiaryBase);\n        }\n    }\n\n    .MuiButton-containedWarning {\n        border-radius: 16px;\n        //padding: 8px 16px;\n        background-color: var(--primaryBase);\n        color: var(--whiteBase);\n\n        &:hover {\n            background-color: var(--primaryBase);\n        }\n    }\n\n    .MuiButton-textPrimary {\n        color: var(--primaryBase);\n        text-transform: capitalize;\n\n        &:hover,\n        &.active {\n            text-decoration: underline;\n        }\n    }\n\n    .MuiButton-textSecondary {\n        color: var(--secondaryBase);\n        text-transform: capitalize;\n\n        &:hover,\n        &.active {\n            text-decoration: underline;\n        }\n    }\n\n    .MuiButton-textWarning {\n        color: var(--primaryBase);\n        text-transform: capitalize;\n\n        &:hover,\n        &.active {\n            text-decoration: underline;\n        }\n    }\n\n    .MuiButtonGroup-root {\n        .MuiButton-colorPrimary {\n            border-radius: 100px;\n            padding: 10px 24px;\n            background-color: var(--primaryBase);\n            color: var(--whiteBase);\n\n            &:hover {\n                background-color: var(--secondaryBase);\n            }\n\n            &.active {\n                background-color: var(--secondaryBase);\n            }\n        }\n\n        .MuiButton-colorInfo {\n            background-color: var(--whiteBase);\n            color: var(--primaryBase);\n            border-color: var(--greyBase) !important;\n\n            &:hover,\n            &.active {\n                background-color: var(--secondaryBase);\n                color: var(--whiteBase);\n            }\n        }\n\n        .MuiButtonGroup-firstButton {\n            border-color: var(--whiteBase);\n            border-radius: 10px 0px 0px 10px;\n\n        }\n\n        .MuiButtonGroup-middleButton {\n            border-color: var(--whiteBase);\n        }\n\n        .MuiButtonGroup-lastButton {\n            border-color: var(--whiteBase);\n            border-radius: 0px 10px 10px 0px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
